import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { StateFromReducersMapObject } from 'redux';

import { type CoreRootState, createGameStore } from '@pp/core/src/store/CoreStore';

import { autoCashoutSlice } from './slices/autocashout/slice';
import { betStepperSlice } from './slices/betStepper/slice';
import { crashAutoplaySlice } from './slices/crashAutoplay/slice';
import { airPlaneSlice } from './slices/highflyerAirPlane/slice';
import { highflyerGameStateSlice } from './slices/highflyerGame/slice';
import { highflyerStateSlice } from './slices/highflyerState/slice';
import { inGameHistorySlice } from './slices/inGameHistory/slice';
import { recentResultDetailStateSlice } from './slices/recentResultDetail/slice';
import { gameSettingsMiddleWare } from './slices/settings/middleware';

const gameReducer = {
  [highflyerStateSlice.name]: highflyerStateSlice.reducer,
  [highflyerGameStateSlice.name]: highflyerGameStateSlice.reducer,
  [recentResultDetailStateSlice.name]: recentResultDetailStateSlice.reducer,
  [betStepperSlice.name]: betStepperSlice.reducer,
  [crashAutoplaySlice.name]: crashAutoplaySlice.reducer,
  [autoCashoutSlice.name]: autoCashoutSlice.reducer,
  [airPlaneSlice.name]: airPlaneSlice.reducer,
  [inGameHistorySlice.name]: inGameHistorySlice.reducer,
};

export const GameStore = createGameStore(gameReducer, { middleware: [gameSettingsMiddleWare.middleware] });
export type GameStore = typeof GameStore;

export type GameRootState = StateFromReducersMapObject<typeof gameReducer> & CoreRootState;
export const useGameSelector: TypedUseSelectorHook<GameRootState> = useSelector;

export type GameDispatch = GameStore['dispatch'];
export const useGameDispatch: () => GameDispatch = useDispatch;
